import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import moment from "moment"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../../lib/blockingFetch"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import FixRecordingInFineract from "../../fragments/FixRecordingInFineract"
import SimpleCheckboxRow from "../../fragments/SimpleCheckboxRow"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { Link } from "react-router"

class GLAccountCard extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    runningFix: false,
    fixDone: false,
    error: null,
  }

  resubmitInFineract = id => {

    this.setState({
      runningFix: true,
      fixDone: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.triggerGLAccountRecording(accessToken, id),
      _ => this.setState({ fixDone: true }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ runningFix: false })
    )
  }

  checkRecording = item => {

    const { fixDone, runningFix, error } = this.state
    if(item.fineractId !== 0 || fixDone || !this.isAdminOrAccountant) return null
    return <FixRecordingInFineract
      running={ runningFix } error={ error }
      onClick={() => this.resubmitInFineract(item.id)}
    />
  }

  renderButtonToolbar = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <div className='align-right'>
        <Button bsStyle="primary" onClick={() => browserHistory.push(`/glaccounts/${id}/update`)}>
          <FontAwesome name='pencil' /> Update
        </Button> &nbsp;

        <Button bsStyle="success" onClick={() => browserHistory.push('/glaccounts/create')}>
          <FontAwesome name='plus-circle' /> New Account
        </Button>
      </div>
    )
  }

  getParentLink = (id, glAccounts) => {

    let link = '-'
    if (id !== null && glAccounts != null) {

      const item = glAccounts.find(elt => elt.id === id)
      if (item) {
        link = <Link to={`/glaccounts/${id}/detail`} title="View">
          { `${ item.name } (${ item.glCode })` }
        </Link>
      }
    }
    return link
  }

  showItem = (item, glAccounts) => {

    if(!item) return null
    const { id, name, glCode, typeFormatted, usageFormatted, description,
      manualEntriesAllowed, disabled, parentId, createdOn } = item

    return (
      <Col md={8} className='detail-content'>

        { this.checkRecording(item) }

        <h2 className={disabled ? 'red' : 'blue' }>{ name }
          { disabled ? <span> <small className="red">(disabled)</small></span> : ''}
        </h2>

        <SimpleCardRow name='GL code' value={ glCode } />
        <SimpleCardRow name='Account type' value={ typeFormatted } />
        <SimpleCardRow name='Account usage' value={ usageFormatted } />
        { parentId && <SimpleCardRow name='Parent' value={ this.getParentLink(parentId, glAccounts) } /> }
        <SimpleCheckboxRow text='Manual Entries Allowed' value={ manualEntriesAllowed } />
        <SimpleCheckboxRow text='Disabled' value={ disabled } />
        <SimpleCardRow name='Description' value={ description ? description : '-' } />
        <SimpleCardRow name='Created On' value={ createdOn ? moment(createdOn).format('lll') : '' }
          className='gray font-size-13' />

        { this.renderButtonToolbar(id) }

      </Col>
    )
  }

  render() {
    const { glAccount, glAccounts } = this.props
    const data = [{ url: '/accounting', title: 'Accounting' }, { url: '/glaccounts', title: 'GL accounts' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ glAccount.name } data={ data } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="sitemap" size="3x" className="detail-icon" />
          </Col>

          { this.showItem(glAccount, glAccounts) }
        </Row>
      </div>
    )
  }
}

GLAccountCard.propTypes = {
  glAccount: PropTypes.object.isRequired,
}

export default GLAccountCard



// WEBPACK FOOTER //
// ./src/components/Accounting/GLAccounts/Card.js